import { render, staticRenderFns } from "./NavMain.vue?vue&type=template&id=01e0e8e1&scoped=true&"
import script from "./NavMain.vue?vue&type=script&lang=js&"
export * from "./NavMain.vue?vue&type=script&lang=js&"
import style0 from "./NavMain.vue?vue&type=style&index=0&id=01e0e8e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e0e8e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBadge,VIcon,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VNavigationDrawer,VSpacer,VSubheader})
